import cz from "./CZ-CZ";
import de from "./DE-DE";
import en from "./EN-EN";
import es from "./ES-ES";
import mx from "./ES-MX";
import fr from "./FR-FR";
import it from "./IT-IT";
import ja from "./JA-JP";
import ko from "./KO-KO";
import pl from "./PL-PL";
import pt from "./PT-BR";
import ru from "./RU-RU";
import tr from "./TR-TR";
import cn from "./ZH-CN";
import tw from "./ZH-TW";

export default {
  ...en,
  ...de,
  ...fr,
  ...pt,
  ...cn,
  ...cz,
  ...es,
  ...it,
  ...ja,
  ...ko,
  ...mx,
  ...pl,
  ...ru,
  ...tr,
  ...tw,
};
